import type { User } from '@/types/auth.types';

export function clobBindingStorageKey(userId: string): string {
  return `porvenix_clob_binding_${userId}`;
}

// Stores the EOA that owns the CLOB credentials so stale keys from a different
// wallet are detected and re-provisioned automatically.
export function clobEoaStorageKey(userId: string): string {
  return `porvenix_clob_eoa_${userId}`;
}

export function readStoredClobBinding(userId: string): User['clobCredentialBinding'] | null {
  if (typeof window === 'undefined') return null;
  const v = window.localStorage.getItem(clobBindingStorageKey(userId));
  if (v === 'deposit_wallet' || v === 'gnosis_safe') return v;
  return null;
}

export function writeStoredClobBinding(
  userId: string,
  binding: NonNullable<User['clobCredentialBinding']>,
  eoaAddress?: string
): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(clobBindingStorageKey(userId), binding);
  if (eoaAddress) {
    window.localStorage.setItem(clobEoaStorageKey(userId), eoaAddress.toLowerCase());
  }
}

export function readStoredClobEoa(userId: string): string | null {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(clobEoaStorageKey(userId));
}

export function clearStoredClobBinding(userId: string): void {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(clobBindingStorageKey(userId));
  window.localStorage.removeItem(clobEoaStorageKey(userId));
}
